<template>
  <div class="user-info">
    <el-form label-width="120px" label-position="left">
      <el-form-item label="头像">
        <Avatar
          :src="userInfo.headPortraitUrl"
          @change="onAvatarChange"
        ></Avatar>
      </el-form-item>
      <el-form-item label="真实姓名">
        <el-input v-model="userInfo.realName" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item label="手机号码">
        <span>{{ userInfo.phoneNum }}</span>
      </el-form-item>
      <el-form-item label="微信名">
        <span>{{ userInfo.wechatNum || "未绑定" }}</span>
      </el-form-item>
      <el-form-item label="登陆密码">
        <el-button @click="resetPassword" type="primary">重置密码</el-button>
      </el-form-item>
      <div class="footer">
        <el-button @click="save" type="primary">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-form>
    <el-dialog v-model="dialogVisible" title="重置密码">
      <AccountAndSafe :user-info="userInfo" />
    </el-dialog>
  </div>
</template>

<script>
import AccountAndSafe from "./accountAndSafe.vue";
import { mapActions } from "vuex";
import Avatar from "@/components/common/Avatar.vue";
export default {
  name: "UserInfo",
  components: {
    AccountAndSafe,
    Avatar,
  },
  props: {
    userInfo: Object,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    ...mapActions(["alertToggle", "fetchData"]),
    onAvatarChange(file) {
      const formData = new FormData();
      formData.append("file", file);
      fetch(location.origin + "/saas/api/web/fileStorage/upload", {
        method: "post",
        body: formData,
        headers: {
          Authorization: localStorage.getItem("Authorization"),
        },
      })
        .then((res) => res.json())
        .then(({ code, data }) => {
          if (code == 200) {
            this.userInfo.headPortrait = data.id;
          }
        });
    },
    resetPassword() {
      this.dialogVisible = true;
    },
    save() {
      this.fetchData({
        url: "USER.POST_SAVE_OR_UPDATE",
        method: "post",
        params: {
          ...this.userInfo,
          headPortrait: this.userInfo.headPortrait,
          realName: this.userInfo.realName,
          phoneNum: this.userInfo.phoneNum,
          userType: this.userInfo.userType,
        },
        isLoading: true,
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (res.success) {
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.info);
        }
      });
    },
    cancel() {},
  },
};
</script>

<style lang="less" scoped>
.user-info {
  padding: 40px 80px;
  .footer {
    display: flex;
    justify-content: center;
  }
}
</style>